import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import QuoteFormPopup from "@/components/QuoteFormPopup";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [lastY, setLastY] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setHidden(y > 80 && y > lastY);
      setLastY(y);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [lastY]);

  const scrollToQuote = () => {
    document.getElementById("quote-form")?.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-[200] bg-[#09090b]/[.92] backdrop-blur-[16px] border-b border-white/[.07] transition-transform duration-300 max-md:hidden`}
    >
      <div className="max-w-[1440px] mx-auto px-[72px] max-lg:px-6 h-[66px] flex items-center justify-between">
        {/* Logo */}
        <QuoteFormPopup>
          <button className="flex items-center gap-2 bg-transparent border-none cursor-pointer p-0">
            <img src="/lovable-uploads/eb926a39-579c-4b26-a436-01b68a7ea94b.webp" alt="Overnightly logo" width="190" height="32" className="h-8 w-auto" fetchPriority="high" />
          </button>
        </QuoteFormPopup>

        {/* Desktop right */}
        <div className="hidden md:flex items-center gap-4">
          <a href="tel:01157181937" className="flex items-center gap-[5px] text-[13px] font-semibold text-white hover:text-muted-foreground transition-colors">
            <Phone className="w-4 h-4" />
            0115 718 1937
          </a>
          <QuoteFormPopup>
            <button
              className="inline-flex items-center gap-[6px] font-bold text-[13px] px-5 py-[10px] rounded-lg bg-accent hover:bg-[#fca311] text-foreground border-none cursor-pointer transition-all hover:-translate-y-px"
            >
              Get My Free Shortlist
            </button>
          </QuoteFormPopup>
        </div>

        {/* Mobile toggle */}
        <button aria-label={mobileMenuOpen ? "Close menu" : "Open menu"} className="md:hidden p-2 text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden px-6 pb-4 border-t border-white/[.07] flex flex-col gap-4 pt-4">
          <a href="tel:01157181937" className="text-white/70 text-sm font-semibold flex items-center gap-2">
            <Phone className="w-4 h-4" /> 0115 718 1937
          </a>
          <QuoteFormPopup>
            <button className="bg-accent text-foreground font-bold text-sm px-5 py-3 rounded-lg">
              Get My Free Shortlist
            </button>
          </QuoteFormPopup>
        </div>
      )}
    </nav>
  );
};

export default Header;
